import * as yup from 'yup';
import { UPLOAD_MAX_SIZE_IMAGE, SUPPORTED_IMAGE_FORMATS } from '../../../utils/constants';

const schema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required('Name is required'),
  description: yup.string().label('Description'),
  internalNotes: yup.string().label('International notes'),
  brandId: yup.string().label('Brand').required('Brand is required'),
  categoryId: yup.string().label('Category').required('Category is required'),
  hsCodeId: yup.string().label('HS Code').required('HS Code is required'),
  reserveMinimum: yup.number().label('reserved minimum'),
  price: yup.number().label('Price'),
  vat: yup.number().label('VAT'),
  photoFront: yup
    .mixed()
    .test('fileSize', 'Max upload file 3MB', (value) => {
      if (typeof value === 'undefined' || value.length <= 0) {
        return true;
      }
      return value[0].size <= UPLOAD_MAX_SIZE_IMAGE;
    })
    .test('fileType', 'Please use filetype JPG, JPEG, or PNG', (value) => {
      if (typeof value === 'undefined' || value.length <= 0) {
        return true;
      }

      return SUPPORTED_IMAGE_FORMATS.includes(value[0].type);
    }),
  photoBack: yup
    .mixed()
    .test('fileSize', 'Max upload file 3MB', (value) => {
      if (typeof value === 'undefined' || value.length <= 0) {
        return true;
      }
      return value[0].size <= UPLOAD_MAX_SIZE_IMAGE;
    })
    .test('fileType', 'Please use filetype JPG, JPEG, or PNG', (value) => {
      if (typeof value === 'undefined' || value.length <= 0) {
        return true;
      }

      return SUPPORTED_IMAGE_FORMATS.includes(value[0].type);
    }),
});

export default schema;
